<template>

  <b-container class="text-white" fluid>

    <b-col lg="12" class="text-center filters">
      <b-col lg="9" class="text-center ml-auto mr-auto">
        <b-row class="text-center justify-content-center">
          <b-col lg="2" class="rounded-1 filter-item py-3" @click="filterProducts()"
                 :class="{'active-filter':('' == activeCategory)}">آخرین محصولات
          </b-col>
          <b-col lg="2" class="rounded-1 filter-item py-3"
                 v-for="category in categories"
                 :key="category.id"
                 v-if="category.products_count > 0"
                 :class="{'btn-primary':(category.id == activeCategory)}"
                 @click="filterProducts(category.id)">
            {{ category.name }}
          </b-col>
        </b-row>
      </b-col>
    </b-col>


    <b-col lg="12" class="mt-4">

      <b-container>
        <b-col class="text-left mb-2">

          <router-link :to="{name:'Products',query:setQueryProduct}" class="text-decoration-none custom-font-size">
            <span>
              <b-icon-arrow-left class="custom-icon-font-size  text-primary"/>
            </span>

            <span class="text-primary">
            مشاهده همه
          </span>

          </router-link>
        </b-col>


        <swiper v-if="products.length > 0" ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="product in products" :key="product.id">


            <product-card :product="product"/>


          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>

      </b-container>


    </b-col>


  </b-container>

</template>

<script>
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import {mapGetters} from "vuex";
import ProductCard from './productCard'

export default {
  name: "ProductList",
  components: {Swiper, SwiperSlide, directive, ProductCard},
  props: {
    is_digital: {
      default: ''
    },
    title: {
      default: ''
    },
    firstCategory: {
      default: 'آخرین محصولات',
    },
    digitalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    physicalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
  },
  data() {
    return {
      activeCategory: '',
      swiperOptions: {
        slidesPerView: 4,
        autoplay: {
          delay: 2000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
          },
          500: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          765: {
            slidesPerView: 3,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          }
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      categories: 'Category/getCategories'
    }),
    setQueryProduct() {
      return this.activeCategory != '' ? {category: this.activeCategory} : {};
    }
  },
  methods: {
    filterProducts(category) {
      if (category > 0) {
        this.activeCategory = category;
        this.$store.commit('Product/setFilters', {key: 'category', value: [category]})
        this.$store.dispatch("Product/setProducts", 1)
      } else {
        this.activeCategory = '';
        this.$store.commit('Product/setFilters', {key: 'category', value: []})
        this.$store.commit('Product/setFilters', {key: 'sort', value: ''})
        this.$store.dispatch("Product/setProducts", 1)
      }
    },
  },
  mounted() {
    this.$store.dispatch('Category/getCategories')
    this.$store.commit('Product/setFilters', {key: 'category', value: []})
    this.$store.commit('Product/setFilters', {key: 'brand', value: []})
    this.$store.commit('Product/setFilters', {key: 'sort', value: ''})
    this.$store.commit('Product/setFilters', {key: 'is_digital', value: this.is_digital})
    this.$store.dispatch("Product/setProducts");
  }

}
</script>


<style>
/* slider buttons */
.swiper-button-next, .swiper-button-prev {
  color: var(--primary) !important;
}

.swiper-pagination-bullet, .swiper-pagination-bullet-active, .swiper-pagination-bullet-active-main {
  color: var(--primary) !important;
  background: var(--primary) !important;
}

/* slider buttons */


#product-305-shopping-card-controller .add-to-cart {
  border-radius: 0 !important;
}

.price-now {
  color: white;
  font-weight: normal;
}

.product-price .d-flex {
  display: inline-block !important;
}


</style>

<style scoped>
.filter-item {
  cursor: pointer;
  background: var(--light-info);
  border: 2px solid var(--light-blue);
  margin-right: -1px;
}

.active-filter {
  border: 2px solid var(--light-success) !important;
  z-index: 1;
  background: var(--light-indigo) !important;
}

.filters:before {
  content: "";
  width: 100%;
  height: 2px;
  background: var(--light-gray);
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
}

.custom-font-size {
  font-size: 20px;
}

</style>

